
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleetColour as ObiLightningHeavySleetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet-colour.js';
 
 
 

 
 export const ObiLightningHeavySleetColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet-colour',
   elementClass: ObiLightningHeavySleetColourElement,
   events: {
     
   }
  });
 
 